import { IconButton } from '../../../components/IconButton';
import { Close, Delete, Edit, Save } from '@material-ui/icons';

export interface SettingItemActionProps {
  canSave?: boolean;
  editing: boolean;
  onCancel(): void;
  onEdit(): void;
  onRemove(): void;
  onSave(): void;
}

const SaveButtons = ({
  canSave,
  editing,
  onCancel,
  onSave,
}: {
  canSave: boolean;
  editing: boolean;
  onCancel(): void;
  onSave(): void;
}) => {
  if (editing === false) return null;
  return (
    <>
      <IconButton disabled={canSave === false} onClick={onSave}>
        <Save />
      </IconButton>
      <IconButton onClick={onCancel}>
        <Close />
      </IconButton>
    </>
  );
};

const EditButtons = ({
  editing,
  onEdit,
  onRemove,
}: {
  editing: boolean;
  onEdit(): void;
  onRemove(): void;
}) => {
  if (editing) return null;
  return (
    <>
      <IconButton onClick={onEdit}>
        <Edit />
      </IconButton>
      <IconButton onClick={onRemove}>
        <Delete />
      </IconButton>
    </>
  );
};

export const SettingItemActions = ({
  canSave = false,
  editing,
  onCancel,
  onEdit,
  onRemove,
  onSave,
}: SettingItemActionProps) => {
  return (
    <div className="inline-flex items-center gap-2">
      <SaveButtons
        canSave={canSave}
        editing={editing}
        onCancel={onCancel}
        onSave={onSave}
      />
      <EditButtons editing={editing} onEdit={onEdit} onRemove={onRemove} />
    </div>
  );
};
